import { Button, Card, Col, Row, Spin } from "antd";
import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import { useState } from "react";
import DoughnutChart from "../common/DoughnutChart";
import BarChart from "../common/BarChart";

export const OverviewCard = (props) => {
  const { title, year, emissionData, abatementData, loading } = props;
  const [pieChartSelected, setPieChartSelected] = useState(0);

  const pieCharts = ["Total Emission", "Abatement", "Net Emission"];

  let totalEmission = 0;

  let chartData = [];
  // Initialize the chart data first to fix the order of appearance
  pieCharts.forEach((chartType) => {
    for (let i = 1; i <= 3; i++) {
      chartData.push({
        emission_type: chartType,
        name: "Scope " + i.toString(),
        value: 0,
      });
    }
  });

  emissionData
    .filter((element) => element.InventoryYear === year.toString())
    .forEach((element) => {
      totalEmission += element.TotalCO2e;

      let idx = chartData.findIndex(
        (e) => e.emission_type === "Total Emission" && e.name === "Scope 1"
      );
      chartData[idx].value += element.Category1CO2e;

      idx = chartData.findIndex(
        (e) => e.emission_type === "Net Emission" && e.name === "Scope 1"
      );
      chartData[idx].value += element.Category1CO2e;

      idx = chartData.findIndex(
        (e) => e.emission_type === "Total Emission" && e.name === "Scope 2"
      );
      chartData[idx].value += element.Category2CO2e;

      idx = chartData.findIndex(
        (e) => e.emission_type === "Net Emission" && e.name === "Scope 2"
      );
      chartData[idx].value += element.Category2CO2e;

      idx = chartData.findIndex(
        (e) => e.emission_type === "Total Emission" && e.name === "Scope 3"
      );
      chartData[idx].value += element.Category3CO2e;

      idx = chartData.findIndex(
        (e) => e.emission_type === "Net Emission" && e.name === "Scope 3"
      );
      chartData[idx].value += element.Category3CO2e;
    });

  abatementData
    .filter((element) => element.Year === year.toString())
    .forEach((element) => {
      let idx = chartData.findIndex(
        (e) =>
          e.emission_type === "Abatement" &&
          e.name === "Scope " + element.Scope.toString()
      );
      chartData[idx].value += element.Quantity * element.EmissionFactor;

      idx = chartData.findIndex(
        (e) =>
          e.emission_type === "Net Emission" &&
          e.name === "Scope " + element.Scope.toString()
      );
      chartData[idx].value -= element.Quantity * element.EmissionFactor;
    });

  let pieChartData = chartData.filter(
    (element) => element.emission_type === pieCharts[pieChartSelected]
  );

  const PieChartSelector = () => {
    const shiftHandler = (change = 1) => {
      let newIndex = pieChartSelected + change;
      if (newIndex < 0) {
        newIndex = pieCharts.length - 1;
      } else if (newIndex >= pieCharts.length) {
        newIndex = 0;
      }
      setPieChartSelected(newIndex);
    };

    const midButton = pieCharts.map((name, index) => {
      return (
        <Col span={2} style={{ height: "100%", width: "10px" }}>
          <Button
            style={{
              padding: "2px 5px",
              height: "100%",
              width: "30px",
              background: pieChartSelected === index ? "grey" : "lightgrey",
              color: "white",
            }}
            onClick={() => {
              setPieChartSelected(index);
            }}
          >
            -
          </Button>
        </Col>
      );
    });

    return (
      <Row style={{ height: "6px", width: "100%", padding: "0px 20px" }}>
        <Col span={5}></Col>
        <Col span={2} style={{ height: "100%", width: "10px" }}>
          <div
            style={{
              padding: "0px 5px",
              height: "100%",
              width: "30px",
              border: "none",
              marginTop: "-7px",
            }}
          >
            <CaretLeftOutlined
              style={{ color: "grey" }}
              onClick={() => {
                shiftHandler(-1);
              }}
            />
          </div>
        </Col>
        <Col span={2} style={{ height: "100%", width: "10px" }}></Col>
        {midButton}
        <Col span={2} style={{ height: "100%", width: "10px" }}></Col>
        <Col span={2} style={{ height: "100%", width: "10px" }}>
          <div
            style={{
              padding: "0px 5px",
              height: "100%",
              width: "30px",
              border: "none",
              marginTop: "-7px",
            }}
          >
            <CaretRightOutlined
              style={{ color: "grey" }}
              onClick={() => {
                shiftHandler(1);
              }}
            />
          </div>
        </Col>
        <Col span={5}></Col>
      </Row>
    );
  };

  return (
    <Card
      size="small"
      title={
        <Row>
          <Col xs={24} sm={24} md={12}>
            <h5 style={{ margin: "0px", fontSize: "17.6px" }}>{title}</h5>
          </Col>
        </Row>
      }
      style={{ width: "100%", height: "100%" }}
    >
      <Row style={{ width: "100%" }}>
        <Col
          xs={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          style={{ width: "100%" }}
        >
          <div style={{ width: "97%" }}>
            <h3 style={{ margin: "0px", textAlign: "center" }}>
              Breakdown of Carbon Emission
            </h3>
          </div>

          <BarChart
            data={chartData}
            x="emission_type"
            y="value"
            color="name"
            style={{
              height: "20vh",
              minHeight: "180px",
              width: "100%",
              padding: "15px 30px",
              display: loading ? "none" : "block",
            }}
            yAxisTitle={"Tons of CO2 (tCO2e)"}
            labelFontSize={12}
            showXAxisTitle={false}
          />
          {loading && (
            <div
              style={{
                width: "100%",
                height: "20vh",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spin />
            </div>
          )}
        </Col>
        <Col
          xs={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          style={{
            width: "100%",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "97%" }}>
            <h3 style={{ margin: "0px", textAlign: "center" }}>
              Total Carbon Emission Structure
            </h3>
          </div>

          {loading && (
            <div
              style={{
                width: "100%",
                height: "20vh",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spin />
            </div>
          )}
          <div
            style={{
              width: "100%",
              display: loading ? "none" : "block",
            }}
          >
            <DoughnutChart
              data={
                // if all values are 0 means data is empty, cuz these are the values being initialised
                pieChartData.every((item) => item.value === 0)
                  ? []
                  : pieChartData
              }
              y="value"
              color="name"
              innerRadius={0.55}
              outerRadius={0.8}
              statisticValueFormatter={(d) =>
                d.toLocaleString("en-US", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                })
              }
              yValueFormatter={(d) =>
                d.toLocaleString("en-US", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                })
              }
              style={{
                height: "18vh",
                minHeight: "176px",
                width: "100%",
                lineHeight: "80%",
              }}
              statisticTitleFontSize={16}
              statisticValueFontSize={12}
            />
            <h3
              style={{
                margin: "0px",
                width: "100%",
                marginTop: pieChartData.every((item) => item.value === 0)
                  ? "12px"
                  : "-12px",
              }}
            >
              {pieCharts[pieChartSelected]}
            </h3>
          </div>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              justifyContent: "center",
              display: loading ? "none" : "block",
              padding: "8px",
            }}
          >
            {PieChartSelector()}
          </div>
        </Col>
      </Row>
    </Card>
  );
};
